import api from "./api";

/**
 * Cliente para o EditingLock cooperativo (Fase 2 do controle de concorrência).
 * Endpoints: /Locks/{entityName}/{entityId}.
 */
const editingLockService = {
  get: async (entityName, entityId) => {
    const response = await api.get(`Locks/${entityName}/${entityId}`);
    return response.data;
  },

  acquire: async (entityName, entityId) => {
    const response = await api.post(`Locks/${entityName}/${entityId}`);
    return response.data;
  },

  heartbeat: async (entityName, entityId) => {
    const response = await api.patch(`Locks/${entityName}/${entityId}/heartbeat`);
    return response.data;
  },

  release: async (entityName, entityId) => {
    await api.delete(`Locks/${entityName}/${entityId}`);
  },

  forceRelease: async (entityName, entityId) => {
    const response = await api.post(`Locks/${entityName}/${entityId}/force`);
    return response.data;
  },
};

export default editingLockService;
